module.exports = __webpack_public_path__ + "img/sanjeev_sir_thumbnail.2b990fd1.jpg";